// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c84bb2d","239":"39f70bb5","667":"c378ad06"}[chunkId] + ".chunk.js";
};